<template>
  <div class="wrapper-card-description">
    <span v-if="hasDate" class="wrapper-date">{{
      dateFormated | removeEndPoint | ladFnCapitalize
    }}</span>

    <div class="post-recent-content">
      <template v-if="isProduct">
        <span class="days-starting-point">{{
          $tc(`${base}.days_starting_point`, item.days, {
            days: item.days,
            // eslint-disable-next-line vue/camelcase
            starting_point: item.starting_point,
            country: item.country.name,
          })
        }}</span>

        <div class="wrapper-reviews">
          <el-rate
            v-if="!!item.reviews.value"
            v-model="item.reviews.value"
            disabled
            show-score
            :score-template="item.reviews.value.toPrecision(3)"
            aria-label="reviews"
          />
          <p v-else class="without-reviews">{{ $t(`${base}.zero_reviews`) }}</p>
        </div>

        <div class="wrapper-price" :class="{ 'show-more': !hasPrice }">
          <!-- eslint-disable -->
          <LadBestPrice
            v-if="hasPrice"
            :total-amount="item.total_amount"
            :promotions="item.promotions"
            :product="{ is_lad: item.is_lad }"
          />
          <!-- eslint-enable -->
          <p v-else class="experience-without-price">
            <small>{{ $t('general.show_more') }}</small>
          </p>
        </div>
      </template>

      <template v-else-if="isPost">
        <h3 class="title">{{ item.title }}</h3>

        <p>{{ item.description }}</p>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadDescriptionCard',
  filters: { removeEndPoint: (text) => text.replace('.', '') },
  props: {
    item: { type: Object, required: true },
    isProduct: { type: Boolean, required: true },
    base: { type: String, required: true },
  },
  computed: {
    ...mapState('settings', ['currency']),
    hasDate() {
      return Reflect.has(this.item, 'date')
    },
    hasPrice() {
      return parseFloat(this.item.total_amount) > 0
    },
    dateFormated() {
      return this.hasDate
        ? this.$dayjs(this.item.date).format('MMMM D, YYYY')
        : ''
    },
    isPost() {
      return this.item.type === 'post'
    },
  },
}
</script>
